import { render, staticRenderFns } from "./BackInStock.vue?vue&type=template&id=4877b35c&scoped=true&"
import script from "./BackInStock.vue?vue&type=script&lang=js&"
export * from "./BackInStock.vue?vue&type=script&lang=js&"
import style0 from "./BackInStock.vue?vue&type=style&index=0&id=4877b35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877b35c",
  null
  
)

export default component.exports